import { AuthAPIsType, APITypes, APIRouteType } from "../types/apiTypes";

export const apiConstants = {
  baseURL: process.env.REACT_APP_BASE_URL,

  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "ClientDb": process.env.REACT_APP_CLIENT_DB,
    "ENVTYPE": `${process.env.REACT_APP_ENV}-${process.env.REACT_APP_CLIENT_DB}`,
    "Accept":"*/*"
  },
};

const defaultPublicRoute: Omit<Omit<APIRouteType, "url">, "method"> = {
  isBodyRequired: false,
  isPathParamsRequired: false,
  isQueryParamsRequired: false,
  isAuthHeaderRequired: false,
  isFileUpload: false,
};

const defaultProtectedRoute: Omit<Omit<APIRouteType, "url">, "method"> = {
  isBodyRequired: false,
  isPathParamsRequired: false,
  isQueryParamsRequired: false,
  isAuthHeaderRequired: true,
  isFileUpload: false,
};


export const authAPIs: AuthAPIsType = {
  signIn: {
    ...defaultPublicRoute,
    url: '/login',
    method: APITypes.POST,
    isBodyRequired: true,
  },
  forgotPassword: {
    ...defaultPublicRoute,
    url: '/forgot_password',
    method: APITypes.POST,
    isBodyRequired: true,
  },
  resetPassword: {
    ...defaultPublicRoute,
    url: '/reset_password',
    method: APITypes.PATCH,
    isBodyRequired: true,
  },
  logout: {
    ...defaultProtectedRoute,
    url: '/logout',
    method: APITypes.DELETE,
  },
  getProviderSpecialities: {
    ...defaultPublicRoute,
    url: '/api/v1/global_doctors/taxonomy_lookup',
    method: APITypes.GET,
  },
  userUpdate: {
    ...defaultProtectedRoute,
    url: '/api/v1/users/:userId',
    method: APITypes.PATCH,
    isBodyRequired: true,
    isPathParamsRequired: true,
    isAuthHeaderRequired: true,
  },
  caseList: {
    ...defaultProtectedRoute,
    url: 'api/v1/cases',
    method: APITypes.GET,
    isQueryParamsRequired: true,
  },
  addUser: {
    ...defaultProtectedRoute,
    url: '/api/v1/users',
    method: APITypes.POST,
    isBodyRequired: true,
  },
  npiLookup: {
    ...defaultPublicRoute,
    url: '/api/v1/global_doctors/npi_lookup',
    method: APITypes.GET,
    isQueryParamsRequired: true,
  },
  addProvider: {
    ...defaultProtectedRoute,
    url: '/api/v1/global_doctors',
    method: APITypes.POST,
    isBodyRequired: true,
  },
  practiceDropdown: {
    ...defaultProtectedRoute,
    url:'/api/v1/cases/practices_dropdown',
    method:APITypes.GET,
  },
  patientDropdown: {
    ...defaultProtectedRoute,
    url:'/api/v1/cases/patients_dropdown',
    method:APITypes.GET,
    isQueryParamsRequired: true,
  },
  providerDropdown: {
    ...defaultProtectedRoute,
    url:'/api/v1/cases/providers_dropdown',
    method:APITypes.GET,
    isQueryParamsRequired: true,
  },
  addEnrollment: {
    ...defaultPublicRoute,
    url: '/api/v1/enrollments',
    method: APITypes.POST,
    isBodyRequired: true,
  },
  getProcedureDropdown: {
    ...defaultProtectedRoute,
    url: '/api/v1/cases/procedure_cpt_dropdown',
    method: APITypes.GET,
  },
  getDiagnosisDropdown: {
    ...defaultProtectedRoute,
    url: '/api/v1/cases/diagnosis_code_dropdown',
    method: APITypes.GET,
    isQueryParamsRequired: true,
  },
  getSiteOfCareDropdown: {
    ...defaultProtectedRoute,
    url: '/api/v1/cases/site_of_care_dropdown',
    method: APITypes.GET,
  },
  addNewCase: {
    ...defaultProtectedRoute,
    url: '/api/v1/cases',
    method: APITypes.POST,
    isBodyRequired: true,
  },
  getPatientDetailsById: {
    ...defaultProtectedRoute,
    url: `/api/v1/cases/patient_data`,
    method: APITypes.GET,
    isQueryParamsRequired: true,
  },
  caseDetail: {
    ...defaultProtectedRoute,
    url: '/api/v1/cases/:caseId',
    method: APITypes.GET,
    isPathParamsRequired: true,
  },
  addNote: {
    ...defaultProtectedRoute,
    url: 'api/v1/notes',
    method: APITypes.POST,
    isBodyRequired: true,
  },
  uploadCaseFile: {
    ...defaultProtectedRoute,
    url: '/api/v1/cases/:caseId/upload_document',
    method: APITypes.POST,
    isBodyRequired: true,
    isPathParamsRequired: true,
    isFileUpload: true,
  },
  downloadZipFile: {
    ...defaultProtectedRoute,
    url: '/api/v1/cases/:caseId/zip_files',
    method: APITypes.GET,
    isBodyRequired: true,
    isPathParamsRequired: true,
  },
  cloneCaseDetails: {
    ...defaultProtectedRoute,
    url: '/api/v1/cases/:caseId/clone_case',
    method: APITypes.GET,
    isPathParamsRequired: true,
  },
  treatmentListing: {
    ...defaultProtectedRoute,
    url: '/api/v1/treatments',
    method: APITypes.GET,
    isQueryParamsRequired: true,
  },
  orderListing: {
    ...defaultProtectedRoute,
    url: '/api/v1/orders',
    method: APITypes.GET,
    isQueryParamsRequired: true,
  },
  createOrder: {
    ...defaultProtectedRoute,
    url: '/api/v1/orders',
    method: APITypes.POST,
    isBodyRequired: true,
  },
  treatmentStatusUpdate: {
    ...defaultProtectedRoute,
    url: '/api/v1/treatments/:treatmentId',
    method: APITypes.PUT,
    isBodyRequired: true,
    isPathParamsRequired: true,
  },
  scheduleRepVisit: {
    ...defaultProtectedRoute,
    url:'/api/v1/rep_visits',
    method: APITypes.POST,
    isBodyRequired: true,
  },
  uploadPEF: {
    ...defaultPublicRoute,
    url:'/api/v1/faxes_ins',
    method: APITypes.POST,
    isBodyRequired: true,
    isFileUpload: true,
  },
  fetchDocument: {
    ...defaultProtectedRoute,
    url:'/api/v1/cases/fetch_document',
    method: APITypes.GET,
    isQueryParamsRequired: true,
  },
  requestTreatmentNotTreating: {
    ...defaultProtectedRoute,
    url:'/api/v1/cases/:caseId/prescriptions/:prescriptionId',
    method: APITypes.PUT,
    isBodyRequired: true,
    isPathParamsRequired: true,
  },
  downloadRequestForm: {
      url:'/api/v1/downloads/get_file',
      method: APITypes.GET,
      ...defaultProtectedRoute,
      isQueryParamsRequired: true,
  },
  patientStatistics: {
    ...defaultProtectedRoute,
    url:'/api/v1/patient_statistics',
    method: APITypes.GET,
    isQueryParamsRequired: true,
  },
  patientDashboard: {
    ...defaultProtectedRoute,
    url:'/api/v1/patient_dashboards',
    method: APITypes.GET,
    isQueryParamsRequired: true,
  },
  userListStatistics: {
    ...defaultProtectedRoute,
    url:'/api/v1/statistics/user_list',
    method: APITypes.GET,
    isQueryParamsRequired: true,
  },
  practiceDoctorDropDownStatistics: {
    ...defaultProtectedRoute,
    url:'/api/v1/patient_statistics/practice_doctor_dropdown',
    method: APITypes.GET,
  },
  actionDashboardData: {
    ...defaultProtectedRoute,
    url:'/api/v1/todos',
    method: APITypes.GET,
    isQueryParamsRequired: true,
  },
  todoActionDashboardStatistic: {
    ...defaultProtectedRoute,
    url:'api/v1/todo_statistics',
    method: APITypes.GET,
    isQueryParamsRequired: true,
  },
  saveNote: {
    ...defaultProtectedRoute,
    url:'/api/v1/notes',
    method: APITypes.POST,
    isBodyRequired: true,
  },
  manufactureStatistics: {
    ...defaultProtectedRoute,
    url:'/api/v1/statistics',
    method: APITypes.GET,
    isQueryParamsRequired: true,
  },
  manufactureStatisticsSocAndDoctorsDropdown: {
    ...defaultProtectedRoute,
    url:'/api/v1/statistics/practice_doctor_list',
    method: APITypes.GET,
    isQueryParamsRequired: true,
  },
  manufactureStatisticsReportDownload: {
    ...defaultProtectedRoute,
    url:'/api/v1/reports/download',
    method: APITypes.GET,
    isQueryParamsRequired: true,
  },
  demoResetCases:{
    url:'/api/v1/cases/reset_demo',
    method: APITypes.PUT,
    isBodyRequired: false,
    isPathParamsRequired: false,
    isQueryParamsRequired: false,
    isAuthHeaderRequired: true,
    isFileUpload: false,
  },
  getGlobalPatientDetailsById: {
    ...defaultProtectedRoute,
    url: `/api/v1/global_patients/:patientId`,
    method: APITypes.GET,
    isPathParamsRequired: true,
  },
  updateGlobalPatientDetailsById: {
    ...defaultProtectedRoute,
    url: `/api/v1/global_patients/:patientId`,
    method: APITypes.PUT,
    isBodyRequired: true,
    isPathParamsRequired: true,
  },
  submiPrecert: {
    ...defaultProtectedRoute,
    url:'/api/v1/cases/:caseId/precerts/:precertId',
    method: APITypes.PUT,
    isBodyRequired: true,
    isPathParamsRequired: true,
    isFileUpload: true,
  },
  reviewPrecertApprove: {
    url:'/api/v1/cases/:caseId/precerts/:precertId/approve',
    method: APITypes.PUT,
    ...defaultProtectedRoute,
    isPathParamsRequired: true,
  },
  reviewPrecertDeny: {
    url:'/api/v1/cases/:caseId/precerts/:precertId/deny',
    method: APITypes.PUT,
    ...defaultProtectedRoute,
    isPathParamsRequired: true,
  },
  appealCase: {
    url:'/api/v1/cases/:caseId/precerts/:precertId/appeal',
    method: APITypes.PUT,
    ...defaultProtectedRoute,
    isPathParamsRequired: true,
  },
  transferCase: {
    url:' /api/v1/cases/:caseId/transfers',
    method: APITypes.POST,
    ...defaultProtectedRoute,
    isPathParamsRequired: true,
    isQueryParamsRequired: true,
  },
  transferRX: {
    url:'/api/v1/cases/:case_id/transfers',
    method: APITypes.POST,
    isBodyRequired: false,
    isPathParamsRequired: true,
    isQueryParamsRequired: true,
    isAuthHeaderRequired: true,
    isFileUpload: false,
  },
  caseDetailPopup: {
    url:'/api/v1/statistics/case_popup',
    method: APITypes.GET,
    isBodyRequired: false,
    isPathParamsRequired: false,
    isQueryParamsRequired: true,
    isAuthHeaderRequired: true,
    isFileUpload: false,
  },
  fetchPrecert: {
    url:'/api/v1/cases/:case_id/precerts/:id/edit',
    method: APITypes.GET,
    isBodyRequired: false,
    isPathParamsRequired: true,
    isQueryParamsRequired: false,
    isAuthHeaderRequired: true,
    isFileUpload: false,
  }, 
  eobsListing: {
    url: '/api/v1/eobs',
    method: APITypes.GET,
    isBodyRequired: false,
    isPathParamsRequired: false,
    isQueryParamsRequired: true,
    isAuthHeaderRequired: true,
    isFileUpload: false,
  },
   fetchEOBsFile: {
    url: '/api/v1/eobs/:id/fetch_eob_file',
    method: APITypes.GET,
    isBodyRequired: false,
    isPathParamsRequired: true,
    isQueryParamsRequired: false,
    isAuthHeaderRequired: true,
    isFileUpload: false,
  },
  eobsDetail: {
    url: '/api/v1/eobs/:id',
    method: APITypes.GET,
    isBodyRequired: false,
    isPathParamsRequired: true,
    isQueryParamsRequired: false,
    isAuthHeaderRequired: true,
    isFileUpload: false,
  },
  eobsUpload: {
    url:'/api/v1/eobs',
    method: APITypes.POST,
    isBodyRequired: true,
    isPathParamsRequired: false,
    isQueryParamsRequired: false,
    isAuthHeaderRequired: true,
    isFileUpload: true,
  },
   getProducts: {
    url:'/api/v1/cases/get_products',
    method: APITypes.GET,
    isBodyRequired: false,
    isPathParamsRequired: false,
    isQueryParamsRequired: false,
    isAuthHeaderRequired: true,
    isFileUpload: false,
  },
   eobsFilterListing: {
    url:'/api/v1/eobs/eob_filters_listing',
    method: APITypes.GET,
    isBodyRequired: false,
    isPathParamsRequired: false,
    isQueryParamsRequired: false,
    isAuthHeaderRequired: true,
    isFileUpload: false,
  },
    markCEP: {
    ...defaultProtectedRoute,
    url:'/api/v1/cases/:caseId',
    method: APITypes.PUT,
    isBodyRequired: true,
    isPathParamsRequired: true,
  },
  ADProviderDropdown: {
    ...defaultProtectedRoute,
    url: 'api/v1/data/fetch_doctors',
    method: APITypes.GET,
    isQueryParamsRequired: true,
  },
  fetchCaseInsurances: {
    ...defaultProtectedRoute,
    url: '/api/v1/cases/:caseId/fetch_insurances',
    method: APITypes.GET,
    isPathParamsRequired: true,
  },
     addQNSpecialist: {
       ...defaultPublicRoute,
       url: '/api/v1/qn_specialists',
       method: APITypes.POST,
       isBodyRequired: true,
     },

  actionDashboardSectionOrder: {
    ...defaultProtectedRoute,
    url: '/api/v1/todo_statistics/todo_statistics_settings',
    method: APITypes.PUT,
    isPathParamsRequired: false,
    isBodyRequired:true
  },
    InsuranceDropdown: {
    url: '/api/v1/master_insurances/search',
    method: APITypes.GET,
    isQueryParamsRequired: true,
    isBodyRequired: false,
    isPathParamsRequired: false,
    isAuthHeaderRequired: true,
    isFileUpload: false,
  },
  PlanDropdown: {
    url: '/api/v1/master_insurance_plans',
    method: APITypes.GET,
    isQueryParamsRequired: true,
     isBodyRequired: false,
    isPathParamsRequired: false,
     isAuthHeaderRequired: true,
    isFileUpload: false,
  },
};

/**
 * @APIErrors Default Errors based on static types
 */
export const ErrorMessages = {
  NetworkError: 'Something went wrong while connecting with services. Please try again in a while',
};
